import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';
import { loadTexts } from '../../config/texts';
import { withStyles } from '@material-ui/core/styles';
import {
  Avatar,
  ButtonBase,
  Divider,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import Storage from '../../util/storage';
const TEXT_KEY = 'profile_menu';

const styles = theme => ({
  nameContainer: {
    padding: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
  },
  avatarButton: {
    borderRadius: '50%',
  },
});

class ProfileMenu extends React.Component {
  state = {
    anchorEl: null,
    texts: loadTexts(TEXT_KEY, this.props.locale)
  };

  _onClickAvatar = event => { this.setState({ anchorEl: event.currentTarget }); };
  _onCloseMenu = () => { this.setState({ anchorEl: null }); };

  _onLogOut = () => {
    this.props.logOut();
    Storage.removeToken();
  };

  render() {
    const { classes, avatar, first, last } = this.props;
    const { anchorEl, texts } = this.state;
    return (
      <React.Fragment>
        <ButtonBase
          onClick={this._onClickAvatar}
          className={classes.button}
          TouchRippleProps={{ classes: { root: classes.avatarButton } }}
        >
          <Avatar alt="avatar" src={avatar}>
            {!avatar && `${first[0]}${last[0]}`}
          </Avatar>
        </ButtonBase>
        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this._onCloseMenu}
        >
          <div className={classes.nameContainer}>
            <Typography>
              {`${first} ${last}`}
            </Typography>
          </div>
          <Divider />
          <MenuItem component={Link} to="/home/profile" onClick={this._onCloseMenu}>
            {texts.profile}
          </MenuItem>
          <MenuItem onClick={this._onLogOut}>
            {texts.logout}
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  avatar: get(state, 'auth.data.user.user.avatar'),
  first: get(state, 'auth.data.user.user.first') || ' ',
  last: get(state, 'auth.data.user.user.last') || ' ',
  locale: get(state, 'appState.locale') || 'en',
});

const mapDispatchToProps = dispatch => ({
  logOut: () => dispatch({ type: 'CLEAR_AUTH' }),
});

export default compose(
  withStyles(styles, { name: 'ProfileMenu' }),
  connect(mapStateToProps, mapDispatchToProps)
)(ProfileMenu);



// WEBPACK FOOTER //
// ./src/modules/auth/ProfileMenu.js